// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-size[data-v-5f20cd89]{max-height:24px}.active[data-v-5f20cd89]{background-color:#e6e6e6}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
